module.exports = "./img/f5c9e6d878fa8a54993fa8cc1b9ede92.jpg";